import { manifests as actionManifests } from './action/manifests.js';
import { manifests as conditionManifests } from './conditions/manifests.js';
import { manifests as defaultTreeItemManifests } from './tree-item/tree-item-default/manifests.js';
import { manifests as defaultTreeManifests } from './default/manifests.js';
import { manifests as entityActionManifests } from './entity-actions/manifests.js';
import { manifests as folderManifests } from './folder/manifests.js';
import { manifests as treeMenuItemManifests } from './tree-menu-item/manifests.js';
import { manifests as treePickerManifests } from './tree-picker-modal/manifests.js';
import { manifests as treeItemCardManifests } from './tree-item-card/manifests.js';
import { manifests as treeViewManifests } from './view/manifests.js';
import { manifests as workspaceViewManifests } from './workspace-view/manifests.js';
import type { UmbExtensionManifestKind } from '@umbraco-cms/backoffice/extension-registry';

export const manifests: Array<UmbExtensionManifest | UmbExtensionManifestKind> = [
	...actionManifests,
	...conditionManifests,
	...defaultTreeItemManifests,
	...defaultTreeManifests,
	...entityActionManifests,
	...folderManifests,
	...treeMenuItemManifests,
	...treePickerManifests,
	...treeItemCardManifests,
	...treeViewManifests,
	...workspaceViewManifests,
];
